import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircleCountdown } from '@/ui/components/CircleCountdown';
import { routes } from '@/routes/routes';
import styles from './KycInProgressPage.module.scss';
import { useKyc, useKycSignalR } from '@/features/kyc/hooks';
import { KycStatus, KycAddressStatus } from '@/features/kyc/types/kyc';

function KycInProgressPage() {
  useKycSignalR();
  const navigate = useNavigate();
  const { kycState, getKycState } = useKyc(true);

  const [timeRemaining, setTimeRemaining] = useState(300); // Start from 5 minutes

  useEffect(() => {
    getKycState();

    const intervalId = setInterval(() => {
      getKycState();
    }, 15000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (timeRemaining > 0) {
      const timer = setTimeout(() => setTimeRemaining(timeRemaining - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      navigate(routes.kyc.failed);
    }
  }, [timeRemaining]);

  useEffect(() => {
    const isInProgress =
      kycState?.status === KycStatus.Submitted ||
      kycState?.status === KycStatus.ReviewRequired ||
      kycState?.addressStatus === KycAddressStatus.InProgress;

    if (!isInProgress && kycState) {
      navigate(routes.kyc.base);
    }
  }, [kycState]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.timerContentWrapper}>
          <CircleCountdown seconds={timeRemaining} totalSeconds={300} />
        </div>
        <h1 className={styles.title}>
          Verificarea identității
          <br /> în procesare…
        </h1>
        <p className={styles.description}>De obicei, durează câteva minute</p>
      </div>
    </div>
  );
}

export default KycInProgressPage;
